export const iconFontAwesomeDesignPenClip = (
	<i className="fa-solid fa-pen-clip"></i>
);
